import flag from './flag';

export const utils = {
  flag,
};
